export enum TherapyTypes {
  Single = 'single',
  Couple = 'couple',
  Children = 'children',
}

// Короткие подписи для переключателей записи и чипа на дашборде. В THERAPY_TYPE_OPTIONS детский тип называется «Для ребёнка»
export const THERAPY_TYPE_TITLES: Record<TherapyTypes, string> = {
  [TherapyTypes.Single]: 'Индивидуальная',
  [TherapyTypes.Couple]: 'Парная',
  [TherapyTypes.Children]: 'Дети',
};

// Запись новых клиентов психолог останавливает отдельно для каждого типа терапии
export const STOPPED_HIRING_FIELD = {
  [TherapyTypes.Single]: 'is_stopped_hiring_new_clients',
  [TherapyTypes.Couple]: 'is_stopped_hiring_couple',
  [TherapyTypes.Children]: 'is_stopped_hiring_children',
} as const;
